import {FETCH_WORKER_REQUEST, FETCH_WORKER_SUCCES, FETCH_WORKER_ERROR} from '../constants/Worker'
import { jsonGet, errorHandler } from '../utils/Request';

const loadWorker = id => (dispatch) => {
  const apiUrl = '/personal/' + id;
  dispatch({
    type: FETCH_WORKER_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_WORKER_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_WORKER_ERROR
      });
      errorHandler(e);
    });
};

export { loadWorker };




// WEBPACK FOOTER //
// ./src/actions/WorkerActions.js